$(function() {
    $('.js-slick-slider').slick({
        infinite: true,
        dots: true,
        arrows: true,
        prevArrow: '<div class="slick-arrow prev"><svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50"><path d="M34.167 6.933L15.848 25.25l18.083 18.083" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
        nextArrow: '<div class="slick-arrow next"><svg viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.833 43.068L34.152 24.75 16.069 6.667" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
    })
})